import cubejs from "@cubejs-client/core";
import jwt from "jsonwebtoken";
import { BaseAddress } from "./config";

export default (options) => {
  const cubejsToken = jwt.sign(options, process.env.REACT_APP_CUBEJS_TOKEN, {
    expiresIn: "30d",
  });

  return cubejs(cubejsToken, {
    apiUrl: BaseAddress.CubeJs,
  });
};
